import axios from "axios";
import { getAccessToken } from "../utils/tokenStore";
import { api_url } from "../utils/ApiContext";

export const fetchCurrentUser = async () => {
  return axios.get(`${api_url}/api/getuser`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
};
